export default {
    "button.continue": "Weiter",
    "button.finish": "Beenden",
    "forgot_password_label_submit": "Passwort vergessen",
    "login.email.placeholder": "E-Mail",
    "login.heading": "Willkommen beim ActiDoo Übersetzungsserver",
    "login.registration.link": "Account erstellen",
    "login_label_password": "Passwort*:",
    "login_label_submit": "Anmelden",
    "password_email_error_invalid": "Bitte geben Sie ein gültiges Passwort ein",
    "projects.create": "Neues Projekt erstellen",
    "projectsForm.delete": "Löschen",
    "projectsForm.fallback.placeholder": "Fallback",
    "projectsForm.heading.editing": "Bearbeite",
    "projectsForm.heading.new": "Neues Projekt",
    "projectsForm.locales.label": "Locales",
    "projectsForm.name.label": "Name",
    "projectsForm.save.new": "Erstellen",
    "projectsForm.save.update": "Speichern",
    "projectsForm.users.label": "Benutzer",
    "projectsList.created_at": "Erstellt am",
    "projectsList.name": "Name",
    "register_company_error_empty": "Bitte geben Sie Ihren Firmennamen ein",
    "register_email_error_invalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "register_email_error_unequal": "Die E-Mail-Adresse stimmt nicht mit der vorherigen E-Mail-Adresse überein",
    "register_firstname_error_empty": "Bitte geben Sie Ihren Vornamen ein",
    "register_label_company_name": "Firma*:",
    "register_label_email": "E-Mail*:",
    "register_label_email_verification": "E-Mail (Bestätigung)*:",
    "register_label_firstname": "Vorname*:",
    "register_label_lastname": "Nachname*:",
    "register_label_submit": "Registrieren",
    "register_lastname_error_empty": "Bitte geben Sie Ihren Nachnamen ein",
    "registration.errors.email_in_use": "Diese E-Mail-Adresse ist bereits registriert.",
    "registration.errors.email_invalid": "Diese E-Mail-Adresse ist ungültig.",
    "registration.errors.email_required": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    "registration.errors.email_verification_code_invalid": "Der E-Mail-Verifizierungscode ist ungültig.",
    "registration.errors.password_confirm": "Die Passwörter stimmen nicht überein.",
    "registration.errors.password_required": "Bitte geben Sie ein Passwort ein.",
    "registration.errors.password_too_short": "Das Passwort muss mindestens 8 Zeichen haben.",
    "registration.errors.upload_error": "Beim Upload ist ein Fehler aufgetreten.",
    "registration.errors.username_in_use": "Der Benutzername wird bereits verwendet.",
    "registration.errors.username_required": "Bitte geben Sie einen Benutzernamen ein.",
    "registration.errors.username_too_short": "Der Benutzername ist zu kurz.",
    "registration.heading": "Einen neuen Account erstellen",
    "selectlist.add": "Hinzufügen",
    "tenants.create": "Mandanten erstellen",
    "tenantsForm.delete": "Löschen",
    "tenantsForm.heading.editing": "Bearbeite",
    "tenantsForm.heading.new": "Neuer Mandant",
    "tenantsForm.name.label": "Name",
    "tenantsForm.save.new": "Erstellen",
    "tenantsForm.save.update": "Speichern",
    "tenantsList.created_at": "Erstellt am",
    "tenantsList.name": "Name",
    "translations_list_editor.iconbar.download_package": "Paket herunterladen",
    "translations_list_editor.iconbar.upload_default_messages": "Upload: Standard-Texte",
    "translations_list_editor.iconbar.upload_locale_messages": "Upload: Übersetzungen",
    "translationslistwitheditor.th.defaultMessage": "Quellcode-Text",
    "translationslistwitheditor.th.fallbackMessage": "Elterntext",
    "translationslistwitheditor.th.id": "ID",
    "translationslistwitheditor.th.translation": "Übersetzung",
    "users.create": "Neuer Benutzer",
    "usersForm.admin.label": "Admin",
    "usersForm.delete": "Löschen",
    "usersForm.email.label": "E-Mail",
    "usersForm.heading.editing": "Bearbeite",
    "usersForm.heading.new": "Neuer Benutzer",
    "usersForm.is_gobal_admin.label": "Globaler Admin",
    "usersForm.is_tenant_admin.label": "Admin (Mandant)",
    "usersForm.is_tenant_translator.label": "Übersetzer (Mandant)",
    "usersForm.locales.label": "Sprachen",
    "usersForm.name.label": "Name",
    "usersForm.old_password.label": "Altes Passwort",
    "usersForm.password.label": "Passwort",
    "usersForm.password_confirm.label": "Passwort (Bestätigung)",
    "usersForm.projects.label": "Projekte",
    "usersForm.save.new": "Erstellen",
    "usersForm.save.update": "Speichern",
    "usersList.created_at": "Erstellt am",
    "usersList.username": "Benutzername",
    "welcome": "Hal"
};



// WEBPACK FOOTER //
// ./src/messages/de.js